var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('page',{attrs:{"slug":"switchboard-activate"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }